 
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import Testimonials from "../../home/common/Testimonials";
import Service from "../../home/carDemo2/Service";
import StepBooking from "../../home/carDemo2/StepBooking";
import Team from "../../home/common/Team";

const AboutUs3Container = () => {
  return (
    <>
      <Breadcrumbs title="About" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section" />
      <Service about />
      <StepBooking />
      <Testimonials type={"about3"} animation={false} />
      <Team type="about3" />
    </>
  );
};

export default AboutUs3Container;
